module.exports = __webpack_public_path__ + "media/application/images/404-img-2-a33361eaa6f8c184ac188f691a8b694a.png";